import { Button } from 'flowbite-react';
import { useCallback, useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import Loader from '../../Common/Loader';
import { useAppSelector } from '../../../Reducers/store';
import { HiPlus } from 'react-icons/hi';
import ClientApi from '../../../Api/ClientApi';
import ClientInventoryMarkUpModal from './ClientInventoryMarkUp';
import { ClientInventoryMarkUp } from '../../../Models/ClientInventoryMarkUp';
import ClientInventoryMarkUpListTable from './ClientInventoryMarkUpListTable';

export default function ClientInventoryMarkUpList({
  clientId,
}: {
  clientId: number;
}) {
  const { userModel } = useAppSelector((state) => state.user);
  const [markupListData, setmarkupListData] = useState<ClientInventoryMarkUp[]>(
    []
  );
  const [selectedClientMarkup, setselectedClientMarkup] =
    useState<ClientInventoryMarkUp | null>(null);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [showModal, setShowModal] = useState<boolean>(false);

  const getClientInventoryMarkUpList = useCallback(() => {
    if (userModel) {
      try {
        setIsLoading(true);
        return ClientApi.getClientInventoryMarkUpList(clientId)
          .then((res) => {
            setmarkupListData(res.data);
            setIsLoading(false);
          })
          .catch((err) => {
            toast.error('Error');
            setIsLoading(false);
          });
      } catch (error) {
        console.error(error);
        toast.error('Error');
        setIsLoading(false);
      }
    }
  }, [clientId]);

  useEffect(() => {
    getClientInventoryMarkUpList();
  }, [getClientInventoryMarkUpList]);

  const handleAddClientInventoryMarkUpClick = () => {
    setselectedClientMarkup(null);
    setShowModal(true);
  };

  const editClientInventoryMarkUp = (markup: ClientInventoryMarkUp) => {
    setselectedClientMarkup(markup);
    setShowModal(true);
  };

  function deleteClientInventoryMarkUp(id: number) {
    const shouldRemove = window.confirm(
      'Are you sure you want to delete this?'
    );

    if (shouldRemove) {
      ClientApi.deleteClientInventoryMarkUp(id)
        .then((res) => {
          if (res.data.success) {
            toast.success(res.data.message);
            getClientInventoryMarkUpList();
          } else {
            toast.success('Error while deleting item');
          }
        })
        .catch((err) => {
          toast.error('Error: ' + err);
        });
    }
  }
  function checkAccess() {
    // if (userModel && userModel.userLevelId === UserLevelNames.SuperAdmin) {
    if (userModel) {
      return true;
    } else {
      return false;
    }
  }

  return (
    <>
      <div className='w-full'>
        {checkAccess() && (
          <div className='w-full flex justify-end'>
            <Button
              onClick={handleAddClientInventoryMarkUpClick}
              className='buttonMain'
            >
              <HiPlus size={20} />
            </Button>
          </div>
        )}
        <div className='w-full p-4'>
          <div className='relative'>
            {isLoading && <Loader />}
            <ClientInventoryMarkUpListTable
              data={markupListData}
              deleteClientInventoryMarkUp={deleteClientInventoryMarkUp}
              editClientInventoryMarkUp={editClientInventoryMarkUp}
            />
          </div>
        </div>
      </div>
      <ClientInventoryMarkUpModal
        show={showModal}
        setShow={setShowModal}
        clientId={clientId}
        getClientInventoryMarkUps={getClientInventoryMarkUpList}
        selectedClientMarkup={selectedClientMarkup}
      />
    </>
  );
}
